import React from 'react';
import classNames from 'classnames';
export const Td = ({ children, className }) => (React.createElement("td", { className: classNames('table-td', className) }, children));
